/**
 * Product Item Carousel
 * Handles image carousel functionality for product cards in grids.
 *
 * Desktop (fine pointer + hover): arrows on hover.
 * Touch / native app / non-desktop: dots + swipe; single tap follows the image link.
 */

function getCarouselContainer(fromEl) {
  return fromEl?.closest?.('.product-item__image-container');
}

function getCarouselSlides(container) {
  return container ? Array.from(container.querySelectorAll('.product-item__image-figure--slide')) : [];
}

function setCarouselIndex(container, index) {
  const slides = getCarouselSlides(container);
  if (!slides.length) return;

  const nextIndex = ((index % slides.length) + slides.length) % slides.length;
  slides.forEach((slide, i) => {
    slide.classList.toggle('active', i === nextIndex);
  });

  const dots = container.querySelectorAll('.product-item__carousel-dot');
  dots.forEach((dot, i) => {
    dot.classList.toggle('active', i === nextIndex);
  });
}

function getActiveCarouselIndex(container) {
  const slides = getCarouselSlides(container);
  const currentSlide = container.querySelector('.product-item__image-figure--slide.active');
  const currentIndex = slides.indexOf(currentSlide);
  return currentIndex >= 0 ? currentIndex : 0;
}

window.productCarouselNext = function (button) {
  const container = getCarouselContainer(button);
  if (!container) return;
  setCarouselIndex(container, getActiveCarouselIndex(container) + 1);
};

window.productCarouselPrev = function (button) {
  const container = getCarouselContainer(button);
  if (!container) return;
  setCarouselIndex(container, getActiveCarouselIndex(container) - 1);
};

function isTouchCarouselDevice() {
  // Prefer real touch / no-hover signals when available.
  if (window.matchMedia('(pointer: coarse)').matches) return true;
  if (window.matchMedia('(hover: none)').matches) return true;
  // Fallbacks when touchscreen can't be detected reliably.
  if (document.documentElement.classList.contains('is-native-app')) return true;
  if (window.matchMedia('(max-width: 768px)').matches) return true;
  if (document.body.classList.contains('touchevents')) return true;
  return false;
}

document.addEventListener('DOMContentLoaded', function () {
  // Keyboard navigation when an arrow is focused
  document.addEventListener('keydown', function (e) {
    const focusedElement = document.activeElement;

    if (focusedElement && focusedElement.classList.contains('product-item__carousel-arrow')) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();

        if (e.key === 'ArrowLeft' && focusedElement.classList.contains('product-item__carousel-arrow--prev')) {
          focusedElement.click();
        } else if (e.key === 'ArrowRight' && focusedElement.classList.contains('product-item__carousel-arrow--next')) {
          focusedElement.click();
        }
      }
    }
  });

  // Touch / swipe support: swipe changes images; tap still follows the product link.
  let touchStartX = 0;
  let touchStartY = 0;
  let currentTouchContainer = null;
  let suppressClickUntil = 0;
  let suppressClickContainer = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isTouchCarouselDevice()) return;
      // Don't steal favorite / arrow interactions
      if (e.target.closest('.favorite-heart, .product-item__carousel-arrow')) {
        currentTouchContainer = null;
        return;
      }

      const container = e.target.closest('.product-item__image-container--carousel');
      if (container) {
        currentTouchContainer = container;
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!currentTouchContainer) return;

      const touchEndX = e.changedTouches[0].clientX;
      const touchEndY = e.changedTouches[0].clientY;
      const deltaX = touchStartX - touchEndX;
      const deltaY = touchStartY - touchEndY;
      const swipeThreshold = 40;

      // Horizontal swipe dominates → change slide and block the synthetic click.
      if (Math.abs(deltaX) > swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX > 0) {
          setCarouselIndex(currentTouchContainer, getActiveCarouselIndex(currentTouchContainer) + 1);
        } else {
          setCarouselIndex(currentTouchContainer, getActiveCarouselIndex(currentTouchContainer) - 1);
        }
        suppressClickUntil = Date.now() + 450;
        suppressClickContainer = currentTouchContainer;
      }

      currentTouchContainer = null;
    },
    { passive: true }
  );

  // After a swipe, suppress the follow-up click so we don't navigate away.
  // Only suppress clicks inside the carousel that was swiped (not other cards).
  document.addEventListener(
    'click',
    function (e) {
      if (Date.now() > suppressClickUntil) {
        suppressClickContainer = null;
        return;
      }
      if (!suppressClickContainer || !suppressClickContainer.contains(e.target)) return;
      const link = e.target.closest('.product-item__image-container--carousel a.product-item__image');
      if (link) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
});
